"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var Input_1 = require("../Input");
var select = function (props) {
    var className = props.className, children = props.children, label = props.label, disabled = props.disabled, _a = props.variant, variant = _a === void 0 ? Input_1.InputVariant.Grey : _a, rest = __rest(props, ["className", "children", "label", "disabled", "variant"]);
    var b = config_1.block("select");
    var cn = b({
        white: variant === Input_1.InputVariant.White,
        grey: variant === Input_1.InputVariant.Grey,
        disabled: disabled,
    });
    var htmlLabel;
    if (label) {
        htmlLabel = react_1.default.createElement("label", null, label);
    }
    return (react_1.default.createElement("div", { className: cn },
        htmlLabel,
        react_1.default.createElement("select", __assign({ disabled: disabled }, rest), children)));
};
exports.default = select;
//# sourceMappingURL=index.js.map